import axios from "axios";
import { Report } from "../Items/Report";
import { Business, PaymentOption } from "../Items/Business";
import { ReportDto } from "../Items/ReportDto";

const API_URL = "https://app.mamadapp.co.il/api/Report"; // עדכן לפי הכתובת שלך
const BUSINESS_API_URL = "https://app.mamadapp.co.il/api/Business"; // עדכן לפי הכתובת שלך

class ReportService {
  // --- GET_REPORTS ---
  async getReports(): Promise<ReportDto[]> {
    const response = await axios.get(API_URL);
    return response.data;
  }
  async getPaymentOptions(): Promise<PaymentOption[]>  {
      // מניח שזה ה-Route של השליפה בשרת, שנה לפי הצורך
      const response = await axios.get(`${BUSINESS_API_URL}/paymentOptions`);
      return response.data;
    }

  // --- ADD_REPORT ---
  async addReport(report: Report): Promise<Report> {
    const payload = {
      companyId: report.jobId,
      amount: report.orderAmount,
      paymentConfirmed: report.isPaymentConfirmation,
      date: report.paymentDate
    };

    const response = await axios.post(API_URL, payload);
    return response.data;
  }

  // --- GET_REPORTS_BY_COMPANY ---
  async getReportsByCompany(
    companyId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<Report[]> {
    const params: any = {};
    if (companyId) params.companyId = companyId;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(`${API_URL}/GetReportsByCompany`, { params });
    return response.data;
  }

  // --- GET_TOTAL_LINE ---
  async getTotalLine(
    companyId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<any> {
    const params: any = {};
    if (companyId) params.companyId = companyId;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;

    const response = await axios.get(`${API_URL}/GetTotalLine`, { params });
    return response.data;
  }

  // --- CHANGE_CONFIRM_PAYMENT ---
  async changeConfirmPayment(reportId: number,paymentOptionId:number): Promise<number> {
    const response = await axios.post(`${API_URL}/ChangeConfirmPayment/${reportId}?paymentMethodId=${paymentOptionId}`);
    return response.status;
  }
}

export default new ReportService();


// import ReportService from "../../services/ReportService";
// import * as actionType from "../action";
// import { Report } from "../../Items/Report";

// // --- GET_REPORTS ---
// export const fetchReports = () => async (dispatch: any) => {
//   try {
//     const reports: Report[] = await ReportService.getReports();
//     dispatch({ type: actionType.GET_REPORTS, payload: reports });
//   } catch (error) {
//     console.error("Error fetching reports", error);
//   }
// };

// // --- ADD_REPORT ---
// export const addReport = (report: Report) => async (dispatch: any) => {
//   try {
//     const newReport: Report = await ReportService.addReport(report);
//     dispatch({ type: actionType.ADD_REPORT, payload: newReport });
//   } catch (error) {
//     console.error("Error adding report", error);
//   }
// };

// // --- GET_REPORTS_BY_COMPANY ---
// export const fetchReportsByCompany = (
//   companyId?: number,
//   fromDate?: string,
//   toDate?: string
// ) => async (dispatch: any) => {
//   try {
//     const reports: Report[] = await ReportService.getReportsByCompany(companyId, fromDate, toDate);
//     dispatch({ type: actionType.GET_REPORTS, payload: reports });
//   } catch (error) {
//     console.error("Error fetching reports by company", error);
//   }
// };

// // --- GET_TOTAL_LINE ---
// export const fetchTotalLine = (
//   companyId?: number,
//   fromDate?: string,
//   toDate?: string
// ) => async () => {
//   try {
//     const totalLine = await ReportService.getTotalLine(companyId, fromDate, toDate);
//     return totalLine;
//   } catch (error) {
//     console.error("Error fetching total line", error);
//   }
// };

// // --- CHANGE_CONFIRM_PAYMENT ---
// export const changeConfirmPayment = (reportId: number) => async (dispatch: any) => {
//   try {
//     const updatedReport: Report = await ReportService.changeConfirmPayment(reportId);
//     dispatch({ type: actionType.EDIT_REPORT, payload: updatedReport });
//   } catch (error) {
//     console.error("Error changing confirm payment", error);
//   }
// };
